// Vision ConditionalLink

import { Auth } from "aws-amplify";
import { get } from "lodash";

export const createVisionCondition = () => {
  return get(Auth, "user.attributes.custom:role") === "ExternalCoach";
};

export const isCompanyAdmin = () => {
  return get(Auth, "user.attributes.custom:role") === "CompanyAdmin";
};
